import { EventEmitter, SimpleChanges, TemplateRef } from '@angular/core';
import { ChangeAttributes } from '../session/schedule-session/change-attributes';
import { ConfirmAttributes } from '../session/schedule-session/confirm-attributes';
import { NgbActiveModal, NgbDropdown, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SessionService } from '../session/session.service';
import { SessionCreateDTO } from '../session/schedule-session/session-create-dto';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogAttributes } from '../session/schedule-session/dialog-attributes';
import { PaymentService } from '../payment/payment.service';
import { User } from '../../core/user/user.model';
import { UserVoucherService } from '../user-voucher/user-voucher.service';
import { UserService } from '../../core/user/user.service';
import { BaseComponent } from '../../shared/base.component';
import { SessionStorageService } from "ngx-webstorage";
import { TrackerService } from '../../core/tracker/tracker.service';
import { BENEFIT_TYPE } from '../../shared/model/voucher.model';
import { AccountService } from '../../core/auth/account.service';
import { FormBuilder, Validators } from "@angular/forms";
import { SessionScheduledPopupComponent } from '../session/schedule-session/session-scheduled-popup/session-scheduled-popup.component';
import { JhiLanguageService } from '../../ng-jhipster/language';
import { JhiEventManager } from '../../ng-jhipster/service';
import { CustomerCareModalComponent } from '../../shared/support/customer-care-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { CalendarEventLinkService } from '../../core/util/calendar-event-link.service';
import { SessionTypeNotAllowedPopupComponent } from '../session/schedule-session/session-type-not-allowed-popup/session-type-not-allowed-popup.component';
import { SessionSettingService } from '../session-setting/session-setting.service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/user/user.service";
import * as i2 from "../session/session.service";
import * as i3 from "../user-voucher/user-voucher.service";
import * as i4 from "@angular/router";
import * as i5 from "../payment/payment.service";
import * as i6 from "ngx-webstorage";
import * as i7 from "@ng-bootstrap/ng-bootstrap";
import * as i8 from "../../core/tracker/tracker.service";
import * as i9 from "../../core/auth/account.service";
import * as i10 from "@angular/forms";
import * as i11 from "../../ng-jhipster/service";
import * as i12 from "../../ng-jhipster/language";
import * as i13 from "@ngx-translate/core";
import * as i14 from "../../core/util/calendar-event-link.service";
import * as i15 from "../session-setting/session-setting.service";
import * as i16 from "@angular/common";
import * as i17 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i18 from "@angular/material/radio";
import * as i19 from "@ctrl/ngx-emoji-mart/ngx-emoji";
import * as i20 from "../session/schedule-session/give-chat-a-try/give-chat-a-try.component";
import * as i21 from "@fortawesome/angular-fontawesome";
import * as i22 from "../session/schedule-session/session-scheduled-popup/session-scheduled-popup.component";
import * as i23 from "../../shared/alert/alert-error.component";
import * as i24 from "../../shared/modal-success/modal-success.component";
import * as i25 from "../../shared/language/find-language-from-key.pipe";
import * as i26 from "../../shared/language/find-flag-code-from-key.pipe";
const _c0 = ["voucherAlreadyUsedDialog"];
const _c1 = ["incorrectVoucherCodeDialog"];
const _c2 = ["alreadyFutureSessionDialog"];
const _c3 = ["expiredVoucherCodeDialog"];
const _c4 = ["usageLimitDialog"];
const _c5 = ["warningSelectedTimeSlotIsNoLongerValidDialog"];
const _c6 = ["okDialog"];
const _c7 = ["noPaymentDialog"];
const _c8 = ["voucherCodeAppliedDialog"];
const _c9 = ["calendarReminderDropdown"];
function PaymentSelectionComponent_div_0_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵelement(1, "span", 34);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r25.selectedUser.login);
} }
function PaymentSelectionComponent_div_0_p_6_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵelement(1, "span", 36);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ngb-rating", 37);
    i0.ɵɵlistener("rateChange", function PaymentSelectionComponent_div_0_p_6_Template_ngb_rating_rateChange_4_listener($event) { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(2); return ctx_r31.confirmAttributes.coach.coachScore = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    const _r23 = i0.ɵɵreference(24);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r26.confirmAttributes.coach.login);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("rate", ctx_r26.confirmAttributes.coach.coachScore)("starTemplate", _r23)("readonly", true);
} }
const _c10 = function (a0) { return { value: a0 }; };
function PaymentSelectionComponent_div_0_p_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵelement(1, "span", 38);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 39);
    i0.ɵɵelement(3, "use", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(4, "span", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", "../../../../content/images/sprite.svg?v=3#duration-clock", null, "xlink");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(2, _c10, ctx_r27.confirmAttributes.duration));
} }
function PaymentSelectionComponent_div_0_span_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 41);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "findLanguageFromKey");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r28.coachLanguages[0]));
} }
function PaymentSelectionComponent_div_0_mat_radio_button_24_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-radio-button", 42);
    i0.ɵɵlistener("change", function PaymentSelectionComponent_div_0_mat_radio_button_24_Template_mat_radio_button_change_0_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(2); return ctx_r34.onSessionLanguageChange($event); });
    i0.ɵɵelementStart(1, "div", 43);
    i0.ɵɵelementStart(2, "div", 44);
    i0.ɵɵelement(3, "ngx-emoji", 45);
    i0.ɵɵpipe(4, "findFlagCodeFromKey");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 46);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "findLanguageFromKey");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sl_r33 = ctx.$implicit;
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", sl_r33)("checked", sl_r33 === (ctx_r29.session == null ? null : ctx_r29.session.langKey));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("emoji", "flag-", i0.ɵɵpipeBind1(4, 4, sl_r33), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 6, sl_r33));
} }
function PaymentSelectionComponent_div_0_button_26_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 47);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_div_0_button_26_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(2); const _r5 = i0.ɵɵreference(6); return ctx_r36.confirmSelection(_r5); });
    i0.ɵɵelementEnd();
} }
const _c11 = function (a0, a1) { return { date: a0, time: a1 }; };
const _c12 = function (a0) { return { "margin-top": a0 }; };
function PaymentSelectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵelement(2, "h3", 16);
    i0.ɵɵelement(3, "br");
    i0.ɵɵelement(4, "p", 17);
    i0.ɵɵtemplate(5, PaymentSelectionComponent_div_0_p_5_Template, 4, 1, "p", 18);
    i0.ɵɵtemplate(6, PaymentSelectionComponent_div_0_p_6_Template, 5, 4, "p", 18);
    i0.ɵɵelementStart(7, "p");
    i0.ɵɵelement(8, "span", 19);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(9, "svg", 20);
    i0.ɵɵelement(10, "use", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(11, "span", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, PaymentSelectionComponent_div_0_p_12_Template, 5, 4, "p", 18);
    i0.ɵɵelementStart(13, "p", 23);
    i0.ɵɵelement(14, "span", 24);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(15, "svg", 25);
    i0.ɵɵelement(16, "use", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(17, "span", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(18, "hr");
    i0.ɵɵelementStart(19, "form", 27);
    i0.ɵɵelementStart(20, "p");
    i0.ɵɵelement(21, "span", 28);
    i0.ɵɵtemplate(22, PaymentSelectionComponent_div_0_span_22_Template, 3, 3, "span", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "mat-radio-group", 30);
    i0.ɵɵtemplate(24, PaymentSelectionComponent_div_0_mat_radio_button_24_Template, 8, 8, "mat-radio-button", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 32);
    i0.ɵɵtemplate(26, PaymentSelectionComponent_div_0_button_26_Template, 1, 0, "button", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r0.isCoach);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isCoach);
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("href", "../../../../content/images/sprite.svg?v=3#calendar-green", null, "xlink");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction2(12, _c11, ctx_r0.confirmAttributes.selectedDate.format("dddd, DD MMMM"), ctx_r0.confirmAttributes.hour));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.confirmAttributes.duration);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(15, _c12, ctx_r0.sessionType === "video" ? "4px" : "0"));
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("href", "../../../../content/images/sprite.svg?v=3#" + ctx_r0.sessionType + "-green", null, "xlink");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("jhiTranslate", "sessionSchedule.paragraph." + ctx_r0.sessionType);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formGroup", ctx_r0.sessionForm);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r0.coachLanguages == null ? null : ctx_r0.coachLanguages.length) == 1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.coachLanguages);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.changeAttributes.hid);
} }
function PaymentSelectionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelement(1, "give-chat-a-try", 49);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("headerWord", ctx_r1.headerWord);
} }
const _c13 = function (a0, a1) { return { "discount": a0, "code": a1 }; };
function PaymentSelectionComponent_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "a", 67);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_div_2_div_8_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(2); return ctx_r40.cancelVoucherCode(); });
    i0.ɵɵelement(2, "fa-icon", 68);
    i0.ɵɵtext(3, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 69);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction2(1, _c13, ctx_r38.voucherDiscount, ctx_r38.code));
} }
function PaymentSelectionComponent_div_2_div_13_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r42 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(2, 1, p_r42.price, p_r42.currencyCode, "symbol", "1.0-2"));
} }
function PaymentSelectionComponent_div_2_div_13_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "del");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r42 = i0.ɵɵnextContext().$implicit;
    const ctx_r44 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(3, 2, p_r42.price, p_r42.currencyCode, "symbol", "1.0-2"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(6, 7, ctx_r44.finalPrice(p_r42), p_r42.currencyCode, "symbol", "1.0-2"));
} }
function PaymentSelectionComponent_div_2_div_13_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r42 = i0.ɵɵnextContext().$implicit;
    const ctx_r45 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind4(2, 1, ctx_r45.finalPrice(p_r42) / p_r42.numberOfCredits, p_r42.currencyCode, "symbol", "1.0-2"), "/s");
} }
const _c14 = function (a0, a1) { return { "en": a0, "nl": a1 }; };
function PaymentSelectionComponent_div_2_div_13_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 78);
} if (rf & 2) {
    const p_r42 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction2(1, _c14, p_r42.promoTextEn, p_r42.promoTextNl));
} }
function PaymentSelectionComponent_div_2_div_13_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 79);
} if (rf & 2) {
    const p_r42 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction2(1, _c14, p_r42.promoTextEn, p_r42.promoTextNl));
} }
const _c15 = function (a0) { return { "discount": a0 }; };
function PaymentSelectionComponent_div_2_div_13_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 80);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r42 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(2, _c15, p_r42.organizationCode.firstSessionDiscount));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(p_r42.organizationCode.firstSessionDiscount);
} }
const _c16 = function (a0) { return { "payment-option-selected": a0 }; };
function PaymentSelectionComponent_div_2_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 70);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_div_2_div_13_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r56); const p_r42 = restoredCtx.$implicit; const ctx_r55 = i0.ɵɵnextContext(2); return ctx_r55.selectPaymentPackage(p_r42); });
    i0.ɵɵelementStart(1, "div", 71);
    i0.ɵɵelementStart(2, "div", 72);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 73);
    i0.ɵɵtemplate(5, PaymentSelectionComponent_div_2_div_13_div_5_Template, 3, 6, "div", 18);
    i0.ɵɵtemplate(6, PaymentSelectionComponent_div_2_div_13_div_6_Template, 7, 12, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, PaymentSelectionComponent_div_2_div_13_div_7_Template, 3, 6, "div", 74);
    i0.ɵɵtemplate(8, PaymentSelectionComponent_div_2_div_13_div_8_Template, 1, 4, "div", 75);
    i0.ɵɵtemplate(9, PaymentSelectionComponent_div_2_div_13_div_9_Template, 1, 4, "div", 76);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, PaymentSelectionComponent_div_2_div_13_div_10_Template, 2, 4, "div", 77);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r42 = ctx.$implicit;
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", p_r42.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c16, (ctx_r39.selectedPricing == null ? null : ctx_r39.selectedPricing.id) === p_r42.id));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(p_r42.productName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r39.eligibleForDiscount(p_r42));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.eligibleForDiscount(p_r42));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", p_r42.displaySessionPrice);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", p_r42.displaySessionPrice);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !p_r42.displaySessionPrice);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (p_r42.organizationCode == null ? null : p_r42.organizationCode.firstSessionDiscount) > 0 && p_r42.numberOfCredits === 1 && ctx_r39.userSessionCount === 0);
} }
function PaymentSelectionComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 50);
    i0.ɵɵelementStart(1, "div", 51);
    i0.ɵɵelementStart(2, "div", 52);
    i0.ɵɵelement(3, "h3", 53);
    i0.ɵɵelementStart(4, "div", 54);
    i0.ɵɵelementStart(5, "input", 55);
    i0.ɵɵlistener("ngModelChange", function PaymentSelectionComponent_div_2_Template_input_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(); return ctx_r57.code = $event; })("click", function PaymentSelectionComponent_div_2_Template_input_click_5_listener() { i0.ɵɵrestoreView(_r58); const ctx_r59 = i0.ɵɵnextContext(); return ctx_r59.reset(); });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 56);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_div_2_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r58); const ctx_r60 = i0.ɵɵnextContext(); return ctx_r60.applyVoucher(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, PaymentSelectionComponent_div_2_div_8_Template, 5, 4, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "hr", 57);
    i0.ɵɵelement(10, "h3", 58);
    i0.ɵɵelementStart(11, "div", 59);
    i0.ɵɵelementStart(12, "div", 60);
    i0.ɵɵtemplate(13, PaymentSelectionComponent_div_2_div_13_Template, 11, 11, "div", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 62);
    i0.ɵɵelementStart(15, "div", 63);
    i0.ɵɵelementStart(16, "button", 64);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_div_2_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r58); const ctx_r61 = i0.ɵɵnextContext(); return ctx_r61.onSubmitPayment(ctx_r61.selectedPricing); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 65);
    i0.ɵɵelementStart(18, "a", 66);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_div_2_Template_a_click_18_listener() { i0.ɵɵrestoreView(_r58); const ctx_r62 = i0.ɵɵnextContext(); return ctx_r62.onCancelPayment(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(6, 4, "sessionSchedule.placeholder.enterVoucher"));
    i0.ɵɵproperty("ngModel", ctx_r2.code);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.voucherBenefitType === ctx_r2.benefitType[1]);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r2.pricingList);
} }
function PaymentSelectionComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "session-scheduled-popup", 81);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selectedUser", ctx_r4.selectedUser)("confirmAttributes", ctx_r4.confirmAttributes)("coachLanguages", ctx_r4.coachLanguages)("sessionType", ctx_r4.sessionType)("session", ctx_r4.session)("sessionId", ctx_r4.sessionId)("isCoach", ctx_r4.isCoach)("isCoronaUser", ctx_r4.isCoronaUser)("googleReminder", ctx_r4.googleReminder)("yahooReminder", ctx_r4.yahooReminder)("outlookReminder", ctx_r4.outlookReminder);
} }
function PaymentSelectionComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 82);
    i0.ɵɵelementStart(1, "fa-icon", 83);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_ng_template_5_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(); return ctx_r65.no(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 84);
    i0.ɵɵelementStart(3, "div", 85);
    i0.ɵɵelementStart(4, "div", 86);
    i0.ɵɵelement(5, "h3", 87);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "jhi-alert-error");
    i0.ɵɵelementStart(7, "div", 88);
    i0.ɵɵelement(8, "p", 89);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 90);
    i0.ɵɵelementStart(10, "div", 91);
    i0.ɵɵelementStart(11, "button", 92);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_ng_template_5_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r66); const ctx_r67 = i0.ɵɵnextContext(); return ctx_r67.openReschedule(); });
    i0.ɵɵelement(12, "span", 93);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 91);
    i0.ɵɵelementStart(14, "button", 94);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_ng_template_5_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r66); const ctx_r68 = i0.ɵɵnextContext(); return ctx_r68.no(); });
    i0.ɵɵelement(15, "span", 95);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 96);
    i0.ɵɵelementStart(17, "div", 97);
    i0.ɵɵelementStart(18, "button", 98);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_ng_template_5_Template_button_click_18_listener() { i0.ɵɵrestoreView(_r66); const ctx_r69 = i0.ɵɵnextContext(); return ctx_r69.openReschedule(); });
    i0.ɵɵelement(19, "span", 93);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "button", 94);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_ng_template_5_Template_button_click_20_listener() { i0.ɵɵrestoreView(_r66); const ctx_r70 = i0.ɵɵnextContext(); return ctx_r70.no(); });
    i0.ɵɵelement(21, "span", 95);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "h5", 99);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_ng_template_5_Template_h5_click_22_listener() { i0.ɵɵrestoreView(_r66); const ctx_r71 = i0.ɵɵnextContext(); return ctx_r71.openCustomerCareModal(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function PaymentSelectionComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r74 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 82);
    i0.ɵɵelementStart(1, "fa-icon", 83);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_ng_template_7_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r74); const ctx_r73 = i0.ɵɵnextContext(); return ctx_r73.no(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 84);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelementStart(4, "div", 100);
    i0.ɵɵelement(5, "h3", 101);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "jhi-alert-error");
    i0.ɵɵelementStart(7, "div", 102);
    i0.ɵɵelement(8, "p", 103);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 104);
    i0.ɵɵelementStart(10, "button", 105);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_ng_template_7_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r74); const ctx_r75 = i0.ɵɵnextContext(); return ctx_r75.refreshAvailabilities(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function PaymentSelectionComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 106);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("titleText", "sessionSchedule.dialog.voucherAlreadyUsedTitle")("message", i0.ɵɵpipeBind1(1, 2, "sessionSchedule.dialog.voucherAlreadyUsedMessage"));
} }
function PaymentSelectionComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 106);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("titleText", "sessionSchedule.dialog.incorrectVoucherCodeTitle")("message", i0.ɵɵpipeBind1(1, 2, "sessionSchedule.dialog.incorrectVoucherCodeMessage"));
} }
function PaymentSelectionComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 106);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("titleText", "")("message", i0.ɵɵpipeBind1(1, 2, "sessionSchedule.dialog.alreadyFutureSessionMessage"));
} }
function PaymentSelectionComponent_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 106);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("titleText", "sessionSchedule.dialog.expiredVoucherCodeTitle")("message", i0.ɵɵpipeBind1(1, 2, "sessionSchedule.dialog.expiredVoucherCodeMessage"));
} }
function PaymentSelectionComponent_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 106);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("titleText", "sessionSchedule.dialog.usageLimitTitle")("message", i0.ɵɵpipeBind1(1, 2, "sessionSchedule.dialog.usageLimitMessage"));
} }
function PaymentSelectionComponent_ng_template_19_modal_success_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 106);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("titleText", "sessionSchedule.dialog.noPaymentTitle")("message", i0.ɵɵpipeBind1(1, 2, "sessionSchedule.dialog.noPaymentMessage"));
} }
function PaymentSelectionComponent_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PaymentSelectionComponent_ng_template_19_modal_success_0_Template, 2, 4, "modal-success", 107);
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r20.selectedPricing === null || ctx_r20.selectedPricing === undefined);
} }
function PaymentSelectionComponent_ng_template_21_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r86 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 113);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_ng_template_21_button_13_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r86); const ctx_r85 = i0.ɵɵnextContext(2); return ctx_r85.router.navigate(["/user-payment"]); });
    i0.ɵɵelementEnd();
} }
const _c17 = function (a0) { return { numberOfSessionsLeft: a0 }; };
function PaymentSelectionComponent_ng_template_21_Template(rf, ctx) { if (rf & 1) {
    const _r88 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 82);
    i0.ɵɵelementStart(1, "fa-icon", 83);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_ng_template_21_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r88); const ctx_r87 = i0.ɵɵnextContext(); return ctx_r87.cancel(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 84);
    i0.ɵɵelementStart(3, "div", 108);
    i0.ɵɵelementStart(4, "div", 100);
    i0.ɵɵelementStart(5, "div", 90);
    i0.ɵɵelement(6, "h3", 109);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 97);
    i0.ɵɵelement(8, "h2", 109);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "jhi-alert-error");
    i0.ɵɵelementStart(10, "div", 102);
    i0.ɵɵelement(11, "p", 110);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 91);
    i0.ɵɵtemplate(13, PaymentSelectionComponent_ng_template_21_button_13_Template, 1, 0, "button", 111);
    i0.ɵɵelementStart(14, "button", 112);
    i0.ɵɵlistener("click", function PaymentSelectionComponent_ng_template_21_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r88); const ctx_r89 = i0.ɵɵnextContext(); const _r3 = i0.ɵɵreference(4); const _r5 = i0.ɵɵreference(6); return ctx_r89.voucherOK(_r3, _r5); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext();
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(2, _c17, ctx_r22.numberOfSessionsLeft));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r22.isCoach);
} }
const _c18 = function () { return ["fas", "star"]; };
const _c19 = function () { return ["far", "star"]; };
function PaymentSelectionComponent_ng_template_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 114);
    i0.ɵɵelementStart(1, "span", 115);
    i0.ɵɵelementStart(2, "em", 116);
    i0.ɵɵelement(3, "fa-icon", 117);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "em", 118);
    i0.ɵɵelement(5, "fa-icon", 117);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const fill_r90 = ctx.fill;
    i0.ɵɵclassProp("full", fill_r90 === 100);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", fill_r90, "%");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(6, _c18));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(7, _c19));
} }
export class PaymentSelectionComponent extends BaseComponent {
    constructor(userService, sessionService, userVoucherService, route, router, paymentService, sessionStorage, modalService, trackerService, accountService, formBuilder, eventManager, languageService, translateService, activeModal, calendarEventLinkService, sessionSettingService) {
        super(sessionStorage, modalService);
        this.userService = userService;
        this.sessionService = sessionService;
        this.userVoucherService = userVoucherService;
        this.route = route;
        this.router = router;
        this.paymentService = paymentService;
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.trackerService = trackerService;
        this.accountService = accountService;
        this.formBuilder = formBuilder;
        this.eventManager = eventManager;
        this.languageService = languageService;
        this.translateService = translateService;
        this.activeModal = activeModal;
        this.calendarEventLinkService = calendarEventLinkService;
        this.sessionSettingService = sessionSettingService;
        this.onScheduleSession = new EventEmitter();
        this.onMakePayment = new EventEmitter();
        this.voucherDiscount = 0;
        this.paymentProvider = ["Cellulant", "Adyen", "Mollie"];
        this.benefitType = BENEFIT_TYPE;
        this.headerWord = 'tryChat';
        this.sessionForm = this.formBuilder.group({ sLanguage: ['', [Validators.required]] });
        this.scheduling = false;
    }
    set sessionId(value) {
        this._sessionId = value;
        if (value) {
            this.isScheduled = 'update';
        }
        else {
            this.isScheduled = null;
        }
    }
    get sessionId() {
        return this._sessionId;
    }
    ngOnInit() {
        this.langChangeSubscription = this.translateService.onLangChange.subscribe(() => {
            this.langKey = this.languageService.getCurrentLanguage();
        });
        this.userService.current().subscribe(() => {
            this.isCustomerCare = this.accountService.isCustomerCare();
        });
        if (this.sessionId) {
            this.sessionService.getSession(this.sessionId).subscribe((res) => {
                this.session = res.body;
                this.updateAvailableSessionTypes();
            }, (err) => {
                console.log(err);
            });
        }
    }
    ngOnChanges(changes) {
        if (changes.pricingList && this.pricingList) {
            // this.selectPaymentPackage(this.pricingList[0]);
        }
        this.updateAvailableSessionTypes();
    }
    updateAvailableSessionTypes() {
        var _a;
        this.sessionDurationByType = null;
        if (this.selectedUser && ((_a = this.confirmAttributes) === null || _a === void 0 ? void 0 : _a.coach)) {
            this.sessionSettingService.getSessionDurationByUserAndCoach(this.selectedUser.id, this.confirmAttributes.coach.id).subscribe(sessionDurationByType => {
                var _a;
                this.sessionDurationByType = sessionDurationByType.body;
                if (this.sessionDurationByType) {
                    if (this.coachLanguages && this.coachLanguages.length) {
                        this.sessionForm.patchValue({ sLanguage: (_a = this.session) === null || _a === void 0 ? void 0 : _a.langKey });
                    }
                }
            });
        }
    }
    confirmSelection(warningRescheduleDialog) {
        this.trackerService.sendActivity("book_confirm_btn_clicked");
        if (this.scheduling)
            return;
        if (this.selectedUser === undefined) {
            let tempUser = new User();
            tempUser.id = 0;
            this.selectedUser = tempUser;
        }
        if (!this.videoChatEnabled) {
            this.sessionType = 'text';
        }
        this.sessionCreateDTO = new SessionCreateDTO(this.confirmAttributes.coach.id, this.confirmAttributes.selectedDate, this.confirmAttributes.hour, this.isCoach, this.selectedUser.id, this.sessionType ? this.sessionType : 'text', this.confirmAttributes.selectedDateString, this.sessionForm.get(['sLanguage']).value ? this.sessionForm.get(['sLanguage']).value : 'en', this.confirmAttributes.duration);
        this.sessionCreateDTO.sessionId = this.sessionId;
        if ((this.isScheduled === "update" && this.isScheduled !== null)) {
            if (this.accountService.isCoach()) {
                this.openReschedule();
            }
            else {
                this.open(warningRescheduleDialog);
            }
        }
        else {
            this.scheduleNew(this.sessionCreateDTO, SessionScheduledPopupComponent);
            this.trackerService.sendActivity("schedule_new_session_completed");
        }
        if (this.isCoach)
            this.changeAttributes.hid = true;
    }
    scheduleNew(sessionCreateDTO, content) {
        this.scheduling = true;
        this.sessionService.scheduleSession(sessionCreateDTO).subscribe(data => {
            this.responseDTO = data;
            if (data.message === "credit") {
                this.changeAttributes.voucherhid = false;
                this.changeAttributes.hid = true;
                this.onMakePayment.emit("make-payment");
            }
            else if (data.message === "no longer valid") {
                this.modalRef = this.modalService.open(this.warningSelectedTimeSlotIsNoLongerValidDialog);
            }
            else if (data.message === "sessionTypeNotAllowed") {
                this.openSessionTypeNotAllowedPopup();
            }
            else {
                this.onScheduleSession.emit(this.responseDTO.session);
                this.open(content);
                this.eventManager.broadcast({ name: 'customerCareInfoUpdated', content: this.sessionCreateDTO.sessionStartTime });
            }
            this.scheduling = false;
        }, () => {
            this.scheduling = false;
        });
    }
    openCustomerCareModal() {
        this.modalService.dismissAll();
        this.modalService.open(CustomerCareModalComponent, { windowClass: 'modal-window', size: 'sm' });
    }
    openReschedule() {
        this.closeAll();
        this.sessionService.reschedule(this.sessionCreateDTO).subscribe(data => {
            var _a;
            this.responseDTO = data;
            if (this.responseDTO.message === "credit") {
                this.changeAttributes.voucherhid = false;
                this.changeAttributes.hid = true;
                this.onMakePayment.emit("make-payment");
            }
            else if (data.message === "no longer valid") {
                this.modalRef = this.modalService.open(this.warningSelectedTimeSlotIsNoLongerValidDialog);
            }
            else if (data.message === "sessionTypeNotAllowed") {
                this.openSessionTypeNotAllowedPopup();
            }
            else {
                this.onScheduleSession.emit(this.responseDTO.session);
                this.trackerService.sendActivity("reschedule_session_completed");
                this.open(SessionScheduledPopupComponent);
                this.eventManager.broadcast({ name: 'customerCareInfoUpdated', content: (_a = this.responseDTO.session) === null || _a === void 0 ? void 0 : _a.sessionStartTime });
            }
        });
    }
    open(content) {
        if (this.responseDTO !== null && this.responseDTO !== undefined) {
            if (this.responseDTO.session !== null && this.responseDTO.session !== undefined) {
                this.createCalendarReminders(this.responseDTO.session);
            }
        }
        const modalRef = this.modalService.open(content, { ariaLabelledBy: "modal-basic-title", backdrop: "static", keyboard: false });
        if (content === SessionScheduledPopupComponent) {
            modalRef.componentInstance.selectedUser = this.selectedUser;
            modalRef.componentInstance.confirmAttributes = this.confirmAttributes;
            modalRef.componentInstance.coachLanguages = this.coachLanguages;
            modalRef.componentInstance.sessionType = this.sessionType;
            modalRef.componentInstance.responseDTO = this.responseDTO;
            modalRef.componentInstance.isCoach = this.isCoach;
            modalRef.componentInstance.isCoronaUser = this.isCoronaUser;
            modalRef.componentInstance.googleReminder = this.googleReminder;
            modalRef.componentInstance.outlookReminder = this.outlookReminder;
            modalRef.componentInstance.yahooReminder = this.yahooReminder;
            modalRef.componentInstance.session = this.responseDTO.session;
            modalRef.componentInstance.momentDate = this.momentDate;
        }
    }
    // https://outlook.office.com/calendar/0/deeplink/compose?allday=false&body=Nice%20description&startdt=2020-04-19T13:30:00Z&enddt=2020-04-19T14:30:00Z&subject=Your%20Inuka%20session&location=Inuka&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent
    createCalendarReminders(session) {
        const calendarEventLinks = this.calendarEventLinkService.generateCalendarEventLinks(session);
        this.googleReminder = calendarEventLinks.google;
        this.outlookReminder = calendarEventLinks.outlook;
        this.yahooReminder = calendarEventLinks.yahoo;
    }
    closeAll() {
        this.modalService.dismissAll();
    }
    close() {
        this.onScheduleSession.emit(this.responseDTO.session);
        this.closeAll();
        this.smoothScrollUp();
        if (!this.router.url.includes("/index-") && !this.isCustomerCare) {
            if (this.isCoach)
                this.router.navigate(["/index-coach"]).then();
            else
                this.router.navigate(["/index-user"]).then();
        }
    }
    donate() {
        this.close();
        window.open("https://www.paypal.com/donate/?cmd=_s-xclick&hosted_button_id=GUXC8KPHJ7XFG", "_blank", "toolbar=yes, scrollbars=yes, resizable=yes, top=400, left=300, width=500, height=500");
    }
    no() {
        this.modalService.dismissAll();
    }
    smoothScrollUp() {
        window.setTimeout(() => {
            window.scrollTo(0, 0); // how far to scroll on each step
        }, 1);
    }
    reset() {
        this.code = '';
    }
    applyVoucher() {
        console.log('apply voucher');
        this.userVoucherService.addCode(this.code, this.selectedUser.id).subscribe((res) => {
            this.trackerService.sendActivity("book_voucherAdded", { 'voucher_code': res.body.voucher.code });
            let voucher = res.body;
            console.log(voucher);
            if (voucher.voucher.code.toLowerCase() === "connectforreal") {
                this.isCoronaUser = true;
            }
            this.numberOfSessionsLeft = voucher.numberOfSessionsLeft;
            if (voucher.voucher.benefitType === this.benefitType[1]) {
                this.voucherDiscount = voucher.voucher.voucherCodeDiscount;
                this.voucherBenefitType = voucher.voucher.benefitType;
            }
            else {
                this.open(this.voucherCodeDialog);
            }
        }, error => {
            if (error.status === 302) {
                this.open(this.voucherAlreadyUsedDialog);
            }
            else if (error.status === 404) {
                this.open(this.incorrectVoucherCodeDialog);
            }
            else if (error.status === 410) {
                this.open(this.expiredVoucherCodeDialog);
            }
            else if (error.status === 403) {
                this.open(this.usageLimitDialog);
            }
        });
    }
    voucherOK(okDialog, warningRescheduleDialog) {
        this.confirmSelection(warningRescheduleDialog);
    }
    selectPaymentPackage(priceElement) {
        this.selectedPricing = priceElement;
    }
    onSubmitPayment(pricing) {
        if (pricing === null || pricing === undefined) {
            console.log('No payment is selected.');
            this.open(this.noPaymentDialog);
            return;
        }
        let route = 'schedule-session';
        sessionStorage.setItem("sessionUserId", this.selectedUser.id.toString());
        this.paymentService.onPayment(pricing, route, this.sessionCreateDTO, this.code);
        this.trackerService.sendActivity("book_payment_btn_clicked");
    }
    onCancelPayment() {
        this.changeAttributes.voucherhid = true;
    }
    finalPrice(p) {
        var _a;
        let firstSessionDiscount = p.organizationCode && p.numberOfCredits === 1 ? (_a = p.organizationCode) === null || _a === void 0 ? void 0 : _a.firstSessionDiscount : 0;
        let discount = this.voucherDiscount + firstSessionDiscount;
        if (this.eligibleFor1stSessionDiscount(p) || this.voucherDiscount > 0) {
            let number = p.price * ((100 - discount) / 100);
            console.log("First session discount: " + firstSessionDiscount + ", voucherDiscount: " + this.voucherDiscount);
            // console.log("discounted price: " + number);
            return number;
        }
        else {
            return p.price;
        }
    }
    cancelVoucherCode() {
        this.voucherDiscount = 0;
        this.voucherBenefitType = '';
    }
    eligibleFor1stSessionDiscount(p) {
        var _a;
        return ((_a = p.organizationCode) === null || _a === void 0 ? void 0 : _a.firstSessionDiscount) > 0 && p.numberOfCredits === 1 && this.userSessionCount === 0;
    }
    eligibleForDiscount(p) {
        return this.voucherBenefitType === this.benefitType[1] || this.eligibleFor1stSessionDiscount(p);
    }
    refreshAvailabilities() {
        if (this.modalRef) {
            this.modalRef.close();
        }
        this.eventManager.broadcast('refreshAvailabilities');
    }
    cancel() {
        this.activeModal.dismiss();
    }
    onSessionTypeChange(event) {
        this.sessionType = event.value;
    }
    onSessionLanguageChange(event) {
        if (this.session)
            this.session.langKey = event.value;
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.langChangeSubscription.unsubscribe();
    }
    openSessionTypeNotAllowedPopup() {
        const modalRef = this.modalService.open(SessionTypeNotAllowedPopupComponent);
        modalRef.componentInstance.sessionType = this.sessionType;
        modalRef.componentInstance.duration = this.confirmAttributes.duration;
    }
}
PaymentSelectionComponent.ɵfac = function PaymentSelectionComponent_Factory(t) { return new (t || PaymentSelectionComponent)(i0.ɵɵdirectiveInject(i1.UserService), i0.ɵɵdirectiveInject(i2.SessionService), i0.ɵɵdirectiveInject(i3.UserVoucherService), i0.ɵɵdirectiveInject(i4.ActivatedRoute), i0.ɵɵdirectiveInject(i4.Router), i0.ɵɵdirectiveInject(i5.PaymentService), i0.ɵɵdirectiveInject(i6.SessionStorageService), i0.ɵɵdirectiveInject(i7.NgbModal), i0.ɵɵdirectiveInject(i8.TrackerService), i0.ɵɵdirectiveInject(i9.AccountService), i0.ɵɵdirectiveInject(i10.FormBuilder), i0.ɵɵdirectiveInject(i11.JhiEventManager), i0.ɵɵdirectiveInject(i12.JhiLanguageService), i0.ɵɵdirectiveInject(i13.TranslateService), i0.ɵɵdirectiveInject(i7.NgbActiveModal), i0.ɵɵdirectiveInject(i14.CalendarEventLinkService), i0.ɵɵdirectiveInject(i15.SessionSettingService)); };
PaymentSelectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaymentSelectionComponent, selectors: [["payment-selection"]], viewQuery: function PaymentSelectionComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
        i0.ɵɵviewQuery(_c3, 5);
        i0.ɵɵviewQuery(_c4, 5);
        i0.ɵɵviewQuery(_c5, 5);
        i0.ɵɵviewQuery(_c6, 5);
        i0.ɵɵviewQuery(_c7, 5);
        i0.ɵɵviewQuery(_c8, 5);
        i0.ɵɵviewQuery(_c9, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.voucherAlreadyUsedDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.incorrectVoucherCodeDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.alreadyFutureSessionDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expiredVoucherCodeDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.usageLimitDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.warningSelectedTimeSlotIsNoLongerValidDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.okDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noPaymentDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.voucherCodeDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calendarReminderDropdown = _t.first);
    } }, inputs: { confirmAttributes: "confirmAttributes", changeAttributes: "changeAttributes", sessionCreateDTO: "sessionCreateDTO", isScheduled: "isScheduled", dialogAttributes: "dialogAttributes", visibleDialogBox: "visibleDialogBox", isCoach: "isCoach", selectedUser: "selectedUser", pricingList: "pricingList", coachLanguages: "coachLanguages", textChatEnabled: "textChatEnabled", videoChatEnabled: "videoChatEnabled", userSessionCount: "userSessionCount", textSessionCount: "textSessionCount", isCoronaUser: "isCoronaUser", selectedTimezone: "selectedTimezone", momentDate: "momentDate", session: "session", langKey: "langKey", sessionType: "sessionType", sessionId: "sessionId" }, outputs: { onScheduleSession: "onScheduleSession", onMakePayment: "onMakePayment" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 25, vars: 3, consts: [["class", "card card-borderless card-green", 4, "ngIf"], ["class", "mt-2 card card-borderless", 4, "ngIf"], ["class", "card card-borderless", 4, "ngIf"], ["okDialog", ""], ["warningRescheduleDialog", ""], ["warningSelectedTimeSlotIsNoLongerValidDialog", ""], ["voucherAlreadyUsedDialog", ""], ["incorrectVoucherCodeDialog", ""], ["alreadyFutureSessionDialog", ""], ["expiredVoucherCodeDialog", ""], ["usageLimitDialog", ""], ["noPaymentDialog", ""], ["voucherCodeAppliedDialog", ""], ["t", ""], [1, "card", "card-borderless", "card-green"], [1, "card-body", 2, "font-size", "16px"], ["jhiTranslate", "sessionSchedule.paragraph.confirmation"], ["jhiTranslate", "sessionSchedule.paragraph.checkBooking", 2, "font-weight", "bold"], [4, "ngIf"], ["jhiTranslate", "sessionSchedule.paragraph.date", 2, "font-weight", "bold"], [2, "height", "18px", "width", "16px", "margin", "0 5px 0 7px"], [0, "xlink", "href", ""], ["jhiTranslate", "sessionSchedule.paragraph.dateValue", 3, "translateValues"], [1, "d-flex", "justify-content-start", "align-items-center"], ["jhiTranslate", "sessionSchedule.paragraph.sessionType", 2, "font-weight", "bold"], [2, "height", "14px", "width", "14px", "margin", "0 5px 0 7px", 3, "ngStyle"], [1, "description", 3, "jhiTranslate"], [3, "formGroup"], ["jhiTranslate", "sessionSchedule.paragraph.sessionLanguage", 1, "form-header"], ["class", "description", 4, "ngIf"], ["formControlName", "sLanguage", 1, "d-flex", "justify-content-between", 2, "flex-flow", "column"], [3, "value", "checked", "change", 4, "ngFor", "ngForOf"], [1, "mt-4", 2, "text-align", "center"], ["jhiTranslate", "sessionSchedule.button.confirmSelection", "class", "btn-2 btn-2-green px-4 session-schedule-confirm-selection-btn", 3, "click", 4, "ngIf"], ["jhiTranslate", "sessionSchedule.paragraph.user", 2, "font-weight", "bold"], [1, "mr-2"], ["jhiTranslate", "sessionSchedule.paragraph.coach", 2, "font-weight", "bold"], ["max", "5", 3, "rate", "starTemplate", "readonly", "rateChange"], ["jhiTranslate", "sessionSchedule.paragraph.duration", 2, "font-weight", "bold"], [2, "height", "18px", "width", "18px", "margin", "0 5px 0 7px"], ["jhiTranslate", "sessionSchedule.paragraph.durationValue", 3, "translateValues"], [1, "description"], [3, "value", "checked", "change"], [1, "d-flex", "justify-content-between", "align-items-center", "description"], [1, "d-flex", "justify-content-between", "align-items-end", "mt-1"], [3, "emoji"], [1, "ml-1"], ["jhiTranslate", "sessionSchedule.button.confirmSelection", 1, "btn-2", "btn-2-green", "px-4", "session-schedule-confirm-selection-btn", 3, "click"], [1, "mt-2", "card", "card-borderless"], [3, "headerWord"], [1, "card", "card-borderless"], [1, "overflow-hidden", "voucher-code-card", 2, "margin-bottom", "0"], [1, "card-body", "p-3"], ["jhiTranslate", "sessionSchedule.header.enterVoucher"], [1, "row", 2, "padding-top", "20px", "padding-left", "16px"], ["id", "session-schedule-enter-voucher-input", 1, "form-control", 2, "width", "75%", 3, "ngModel", "placeholder", "ngModelChange", "click"], ["id", "session-schedule-enter-voucher-submit", "jhiTranslate", "sessionSchedule.a.apply", 1, "btn-2", "btn-2-success", "font-weight-bold", "voucher-apply-button", 3, "click"], [2, "margin-top", "0"], ["jhiTranslate", "sessionSchedule.header.selectPackage", 2, "padding", "5px 20px 0 20px"], [1, "card-body"], ["id", "schedule-session-price-list"], [3, "id", "click", 4, "ngFor", "ngForOf"], [1, "row", "mt-4"], [1, "column", 2, "float", "left", "width", "50%", "padding", "5px"], ["id", "make-payment-button", "jhiTranslate", "sessionSchedule.a.makePayment", 1, "btn-2", "btn-2-black", "px-4", 2, "float", "left", 3, "click"], [1, "column", 2, "float", "right", "width", "50%", "padding", "5px"], ["jhiTranslate", "sessionSchedule.a.cancel", 1, "btn-2", "btn-2-success", 2, "color", "#44A38D", "float", "right", "padding-right", "10px", 3, "click"], [3, "click"], ["icon", "times"], ["jhiTranslate", "sessionSchedule.voucherCodeDiscount", 3, "translateValues"], [3, "id", "click"], [1, "row", "py-3", "my-2", "payment-option", 3, "ngClass"], [1, "col-3", "pl-2", "pr-1", "my-auto"], [1, "col-3", "px-1", "my-auto"], ["class", "col-3 px-1 my-auto", 4, "ngIf"], ["class", "col-3 pl-1 pr-2 my-auto text-danger", "jhiTranslate", "global.providedByBackend", 3, "translateValues", 4, "ngIf"], ["class", "col-6 pl-1 pr-2 my-auto text-danger", "jhiTranslate", "global.providedByBackend", 3, "translateValues", 4, "ngIf"], ["class", "col-12 text-danger", "jhiTranslate", "sessionSchedule.firstSessionDiscount", 3, "translateValues", 4, "ngIf"], ["jhiTranslate", "global.providedByBackend", 1, "col-3", "pl-1", "pr-2", "my-auto", "text-danger", 3, "translateValues"], ["jhiTranslate", "global.providedByBackend", 1, "col-6", "pl-1", "pr-2", "my-auto", "text-danger", 3, "translateValues"], ["jhiTranslate", "sessionSchedule.firstSessionDiscount", 1, "col-12", "text-danger", 3, "translateValues"], [3, "selectedUser", "confirmAttributes", "coachLanguages", "sessionType", "session", "sessionId", "isCoach", "isCoronaUser", "googleReminder", "yahooReminder", "outlookReminder"], [1, "olha-theme"], ["icon", "times-circle", 1, "close", 3, "click"], [1, "main-body"], [1, "modal-body"], [1, "header", "justify-content-start"], ["jhiTranslate", "sessionChat.header.reschedule"], [1, "font-weight-bold", "justify-content-start"], ["jhiTranslate", "sessionChat.paragraph.rescheduleSession"], [1, "d-sm-none"], [1, "text-center"], ["type", "button", 1, "btn", "btn-primary", "reschedule-confirmation-button-primary", 3, "click"], ["jhiTranslate", "sessionChat.button.rescheduleYes"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", "reschedule-confirmation-button-secondary", 3, "click"], ["jhiTranslate", "sessionChat.word.no"], [1, "d-flex", "justify-content-end"], [1, "d-none", "d-sm-block", "d-md-block", "d-lg-block", "d-xl-block"], ["id", "session-reschedule-confirm-btn", "type", "button", 1, "btn", "btn-primary", "reschedule-confirmation-button-primary", 3, "click"], ["jhiTranslate", "sessionChat.button.customerSupport", "data-dismiss", "modal", 1, "text-center", "customer-support", 3, "click"], [1, "header"], ["jhiTranslate", "sessionSchedule.header.selectedTimeSlotIsNoLongerValid"], [1, "font-weight-bold"], ["jhiTranslate", "sessionSchedule.dialog.selectedTimeSlotIsNoLongerValid"], [1, "float-right", "mb-3"], ["type", "button", "jhiTranslate", "sessionSchedule.button.refresh", 1, "btn", "btn-primary", "reschedule-confirmation-button", 3, "click"], [3, "titleText", "message"], [3, "titleText", "message", 4, "ngIf"], [1, "modal-body", "text-center"], ["jhiTranslate", "sessionSchedule.paragraph.voucherCodeApplied"], ["id", "modal-success-message", "jhiTranslate", "sessionSchedule.paragraph.numberOfSessionsLeft", 1, "text-center", 3, "translateValues"], ["type", "button", "class", "btn btn-secondary justify-content-center", "jhiTranslate", "sessionSchedule.button.buyMore", "aria-label", "", "style", "display: inline-block;", 3, "click", 4, "ngIf"], ["type", "button", "id", "session-schedule-voucher-success-continue-btn", "jhiTranslate", "sessionSchedule.button.continue", "aria-label", "", 1, "btn", "btn-primary", "justify-content-center", 3, "click"], ["type", "button", "jhiTranslate", "sessionSchedule.button.buyMore", "aria-label", "", 1, "btn", "btn-secondary", "justify-content-center", 2, "display", "inline-block", 3, "click"], [1, "star"], [1, "half"], [1, "text-warning"], [3, "icon"], [1, "text-warning", "cursor"]], template: function PaymentSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PaymentSelectionComponent_div_0_Template, 27, 17, "div", 0);
        i0.ɵɵtemplate(1, PaymentSelectionComponent_div_1_Template, 2, 1, "div", 1);
        i0.ɵɵtemplate(2, PaymentSelectionComponent_div_2_Template, 19, 6, "div", 2);
        i0.ɵɵtemplate(3, PaymentSelectionComponent_ng_template_3_Template, 1, 11, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(5, PaymentSelectionComponent_ng_template_5_Template, 23, 0, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(7, PaymentSelectionComponent_ng_template_7_Template, 11, 0, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(9, PaymentSelectionComponent_ng_template_9_Template, 2, 4, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(11, PaymentSelectionComponent_ng_template_11_Template, 2, 4, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(13, PaymentSelectionComponent_ng_template_13_Template, 2, 4, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(15, PaymentSelectionComponent_ng_template_15_Template, 2, 4, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(17, PaymentSelectionComponent_ng_template_17_Template, 2, 4, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(19, PaymentSelectionComponent_ng_template_19_Template, 1, 1, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(21, PaymentSelectionComponent_ng_template_21_Template, 15, 4, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(23, PaymentSelectionComponent_ng_template_23_Template, 6, 8, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.changeAttributes.hid || !ctx.changeAttributes.voucherhid);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.textSessionCount === 0 && ctx.sessionType === "video" && !ctx.isCoach);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.changeAttributes.voucherhid);
    } }, directives: [i16.NgIf, i17.JhiTranslateDirective, i16.NgStyle, i10.ɵNgNoValidate, i10.NgControlStatusGroup, i10.FormGroupDirective, i18.MatRadioGroup, i10.NgControlStatus, i10.FormControlName, i16.NgForOf, i7.NgbRating, i18.MatRadioButton, i19.EmojiComponent, i20.GiveChatATryComponent, i10.DefaultValueAccessor, i10.NgModel, i21.FaIconComponent, i16.NgClass, i22.SessionScheduledPopupComponent, i23.AlertErrorComponent, i24.ModalSuccessComponent], pipes: [i25.FindLanguageFromKeyPipe, i26.FindFlagCodeFromKeyPipe, i13.TranslatePipe, i16.CurrencyPipe], styles: ["h4[_ngcontent-%COMP%]{font-size:1.5rem}.payment-option[_ngcontent-%COMP%]{border:2px solid #c1c1c1;border-radius:10px}.payment-option[_ngcontent-%COMP%]:hover{background-color:#eef6f4}.payment-option-selected[_ngcontent-%COMP%]{border:2px solid #333;background-color:#eef6f4}.checkbox-wrapper[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #eef6f4;border-collapse:collapse;border-radius:.4rem;margin-left:.2rem;margin-right:.2rem}.checkbox-wrapper[_ngcontent-%COMP%]:hover{background-color:#eef6f4}.checkbox-wrapper[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]:checked{background-color:#44a38d}.star[_ngcontent-%COMP%]{position:relative;display:inline-block;font-size:1rem}.half[_ngcontent-%COMP%]{position:absolute;display:inline-block;overflow:hidden}.text-warning[_ngcontent-%COMP%]{color:#44a38c !important}modal-success[_ngcontent-%COMP%]{padding:10px}#session-schedule-enter-voucher-input[_ngcontent-%COMP%]{border:1px solid #44a38c !important;font-size:15px}[_nghost-%COMP%]  .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle{border-color:#44a38c !important}[_nghost-%COMP%]  .mat-radio-button.mat-accent .mat-radio-inner-circle{color:#44a38c !important;background-color:#44a38c !important}[_nghost-%COMP%]  .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element{background-color:#44a38c !important}.main-body[_ngcontent-%COMP%]{padding:30px 30px 20px 30px}.close[_ngcontent-%COMP%]{color:gray;font-size:20px;cursor:pointer;padding:10px}.header[_ngcontent-%COMP%]{margin-top:10px}.modal-body[_ngcontent-%COMP%]{padding:0}.btn[_ngcontent-%COMP%]{margin:5px;height:36px;padding:0}.reschedule-confirmation-button-primary[_ngcontent-%COMP%]{width:150px !important}.reschedule-confirmation-button-secondary[_ngcontent-%COMP%]{width:76px !important;min-width:70px !important}.customer-support[_ngcontent-%COMP%]{color:#44a38b;text-decoration:underline;margin-top:20px;cursor:pointer}.header[_ngcontent-%COMP%]{font-weight:bold;font-family:Poppins,sans-serif;font-size:16px !important}.description[_ngcontent-%COMP%]{font-family:\"Open Sans\",sans-serif}mat-radio-button[_ngcontent-%COMP%]{font-size:16px !important}ngx-emoji[_ngcontent-%COMP%]{font-size:10px !important;padding-right:3px}"] });
